import { NgModule } from '@angular/core';
//import { CommonModule } from '@angular/common';
//import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule            } from '@angular/material/card';
import { MatIconModule            } from '@angular/material/icon';
import { MatToolbarModule         } from '@angular/material/toolbar';
import { MatButtonModule          } from '@angular/material/button';
import { MatFormFieldModule       } from '@angular/material/form-field';
import { MatInputModule           } from '@angular/material/input';
import { MatSidenavModule         } from '@angular/material/sidenav';
import { MatCheckboxModule        } from '@angular/material/checkbox';
import { MatNativeDateModule      } from '@angular/material/core';
import { MatListModule            } from '@angular/material/list';
import { MatTreeModule            } from '@angular/material/tree';
import { MatRadioModule           } from '@angular/material/radio';
import { MatMenuModule            } from '@angular/material/menu';
import { MatProgressBarModule     } from '@angular/material/progress-bar';
import { MatTooltipModule         } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AlertModule } from 'ngx-bootstrap/alert';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminModule } from './admin/admin.module';
import { SharedModule } from './shared/shared.module';
import { DatePipe } from '@angular/common';
import { GtagModule } from 'angular-gtag';
import { Title, BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { BnNgIdleService } from 'bn-ng-idle';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MsalInterceptorConfiguration, MsalGuardConfiguration, MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    //CommonModule,
    AlertModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    QuillModule.forRoot(),
    BrowserModule,

    NgbModule,

    FontAwesomeModule,
    StorageServiceModule,
    CarouselModule.forRoot(),
    PopoverModule.forRoot(),
    ModalModule.forRoot(),
    MatCardModule, MatIconModule, MatToolbarModule, MatButtonModule,
    MatFormFieldModule, MatInputModule, MatSidenavModule, MatCheckboxModule, MatNativeDateModule,
    MatListModule, MatTreeModule, MatRadioModule, MatMenuModule, MatProgressBarModule, MatTooltipModule,
    MatProgressSpinnerModule,
    FormsModule, ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }), LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.ERROR,
      disableConsoleLogging: false
    }),
    SharedModule,
    AdminModule,
    AppRoutingModule,
    GtagModule.forRoot({ trackingId: 'UA-156349883-1', trackPageviews: true })
  ],
  providers: [HttpClient, HttpClientModule, DatePipe, Title, BnNgIdleService],
  exports: [TranslateModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
